import { PEER_CONFIGURATION_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { fetchGetPeerConfigurationFailure, fetchGetPeerConfigurationSuccess } from "./reducer";

export const getPeerConfiguration = (setLoading,peerName) => (dispatch) => {
    setLoading(true);
    determineBaseUrlAndPerformApiCall(`${PEER_CONFIGURATION_API}/${peerName}`, 'GET')
        .then((response) => {
            setLoading(false);
            dispatch(fetchGetPeerConfigurationSuccess(response));
        })
    .catch ((errorResp) => { dispatch(fetchGetPeerConfigurationFailure(errorResp.message)); })
}